import { ApiService } from "./api.service";
import type { TWorkspacePasswordPolicy, TWorkspacePasswordPolicyUpdate } from "@/types/workspace";

export class WorkspacePasswordPolicyService extends ApiService {
  async getPasswordPolicy(slug: string): Promise<TWorkspacePasswordPolicy> {
    return this.get(`/api/workspaces/${slug}/password-policy/`);
  }

  async updatePasswordPolicy(
    slug: string,
    data: TWorkspacePasswordPolicyUpdate,
  ): Promise<TWorkspacePasswordPolicy> {
    return this.patch(`/api/workspaces/${slug}/password-policy/`, data);
  }
}
